import { render } from "./MovementRow.vue?vue&type=template&id=131aad02&scoped=true&ts=true"
import script from "./MovementRow.vue?vue&type=script&lang=ts"
export * from "./MovementRow.vue?vue&type=script&lang=ts"

import "./MovementRow.vue?vue&type=style&index=0&id=131aad02&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-131aad02"]])

export default __exports__